import { AppLayout } from '@/components/layout';

/**
 * Point d'entrée du layout principal.
 * Délègue à AppLayout pour la structure détaillée.
 */
function MainLayout() {
  return <AppLayout />;
}

export default MainLayout;
